import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('premier-league-widget')
export class PremierLeagueWidget extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin: 1.5rem 0;
      padding: 1rem 1.25rem;
      background: var(--bg-secondary, #f6f6f2);
      border: 1px solid var(--border-color, #e5e5de);
      border-radius: 6px;
      font-family: var(--font-mono, monospace);
    }
    .widget-header {
      font-weight: 600;
      font-size: 0.9rem;
      color: var(--accent-color, #245590);
      margin-bottom: 0.5rem;
    }
    .widget-body {
      font-size: 0.85rem;
      color: var(--text-secondary, #4a4a45);
    }
  `;

  @property({ type: String }) title = 'Interactive Prediction Widget';

  render() {
    return html`
      <div class="widget-header">⚽ ${this.title}</div>
      <div class="widget-body">
        Article-specific Lit component loaded directly from <code>projects/premier-league-predictions/premier-league-widget.ts</code>!
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'premier-league-widget': PremierLeagueWidget;
  }
}
